<template>
  <sustainability :sustainability-data="payload"></sustainability>
</template>

<script>
// "Sostenibilità" (Sustainability), IBIPs-only, product-level only. Uses
// views/ProductDetails/Sustainability.vue (prop-driven, no Vuex/parent coupling).
// SustainabilitySectionBuilder returns SustainabilityInfoDto directly, the exact shape the
// component's `sustainabilityData` prop consumes (`{ articleNumber, otherInfo: { pai,
// esgBenchmark, percentageOther, percentageNotDefined, percentageOther*Investment(s) } }`) — no
// adapter needed (as with TargetMarketSection.vue).
import Sustainability from '../../../views/ProductDetails/Sustainability'

export default {
  name: 'sustainability-section',
  components: {
    Sustainability,
  },
  props: {
    payload: { type: Object, default: null },
  },
}
</script>
